export default __webpack_public_path__ + "static/media/banner-landing.22d7fc4e.jpeg";